import { ContentPenEdit, EyeOff, HandRight } from '@sravni/react-icons';

export const TIP_TEXTS = [
  {
    iconComponent: <ContentPenEdit />,
    title: 'Будьте конструктивны',
    text: 'Объективно оцените и плюсы и минусы продукта, чтобы сравнивать было легче',
    iconColor: 'orange' as const,
  },
  {
    iconComponent: <HandRight />,
    title: 'Будьте вежливы ',
    text: 'А мы постараемся помочь вам решить проблему, если она возникла',
    iconColor: 'green' as const,
  },
  {
    iconComponent: <EyeOff />,
    title: 'Берегите свои данные',
    text: 'Не вносите личные данные или данные о договоре в текст отзыва',
    iconColor: 'blue' as const,
  },
];
